import PropTypes from 'prop-types';
import React from 'react';
import Sticky from 'react-stickynode';
import { GoogleDFP } from '@surfline/quiver-react';
import loadAdConfig from '../../utils/adConfig';

const FeedAdUnit = ({ isDesktop, qaFlag }) => {
  const adType = isDesktop ? 'feed' : 'feed_mobile';
  const feedAdUnit = (
    <div className="sl-feed-ad-unit">
      <GoogleDFP adConfig={loadAdConfig(adType, [['qaFlag', qaFlag]])} />
    </div>
  );
  return isDesktop ? (
    <Sticky
      innerActiveClass="sticky-inner-wrapper--active"
      bottomBoundary=".quiver-page-rail--right"
    >
      {feedAdUnit}
    </Sticky>
  ) : (
    feedAdUnit
  );
};

FeedAdUnit.propTypes = {
  isDesktop: PropTypes.bool,
  qaFlag: PropTypes.string,
};

FeedAdUnit.defaultProps = {
  isDesktop: false,
  qaFlag: null,
};

export default FeedAdUnit;
